import { FC } from "react";

import { Stack } from "@mui/material";

import { BaseStep1Layout, BaseStep1LayoutProps } from "../shared/BaseStep1Layout";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";

export type PeerToPeerPrimaryCampaignStep1LayoutProps = Omit<BaseStep1LayoutProps, "slots"> & {
  slots: {
    banner?: React.ReactNode;
    summary: React.ReactNode;
    coreInfo?: React.ReactNode;
    fundraisers?: React.ReactNode;
    donors?: React.ReactNode;
    donateOrFundraiseOptions: React.ReactNode;
    divider?: React.ReactNode;
  };
};

export const PeerToPeerPrimaryCampaignStep1Layout: FC<PeerToPeerPrimaryCampaignStep1LayoutProps> = ({
  slots,
  isOneColumn,
  isEmbed,
  ...rest
}) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <BaseStep1Layout
      {...rest}
      isOneColumn={isOneColumn}
      isEmbed={isEmbed}
      slots={{
        banner: slots.banner,
        info: (
          <Stack alignItems="flex-start" width="100%" gap={2}>
            {slots.summary}
            {!isSmallScreen && slots.donors}
          </Stack>
        ),
        order: (
          <Stack width="100%" gap={2}>
            {!isSmallScreen && slots.coreInfo}
            {!isEmbed && slots.divider}
            <Stack width="100%" gap={isSmallScreen ? 3 : 5}>
              <Stack marginBlockStart={isSmallScreen ? 0 : 3}>{slots.donateOrFundraiseOptions}</Stack>
              {!isEmbed && slots.divider}
              {slots.fundraisers && (
                <Stack width="100%" gap={2}>
                  {slots.fundraisers}
                </Stack>
              )}
            </Stack>
            {isSmallScreen && slots.donors}
          </Stack>
        ),
      }}
    />
  );
};
